export default __webpack_public_path__ + "static/media/triangle-pattern_cri-090.d1b48b38.jpg";